import { AgentDetails } from '@zet/customer'

export const getTrackEventForScreenView = (agentData: AgentDetails) => {
  if (!agentData?.onecodeId) {
    return {}
  }

  const { onecodeId: user_ID, partnerId: partner_ID, brandComms } = agentData

  let payload: IScreenViewPayload = {
    user_ID,
    screen_name: 'add-customer_generic_step-0',
  }

  if (partner_ID) {
    const brandCommsObj = parseBrandComms(brandComms)

    payload = {
      ...payload,
      partner_ID: partner_ID.toString(),
      screen_name: 'add-customer_brand-specific_step-0',
      brand_name: brandCommsObj?.name,
      category_ID: brandCommsObj?.categoryId,
    }
  }

  return payload
}

export const getTrackEventForClickAction = (
  agentData: AgentDetails,
  additionalData: {
    fullName: string
    phoneNumber: string
    customerIntent: string | undefined
    email?: string
  }
) => {
  if (!agentData?.onecodeId) {
    return {}
  }

  const { onecodeId: user_ID, partnerId: partner_ID, brandComms } = agentData

  let payload: IClickActionPayload = {
    user_ID,
    item_name: 'add-customer_generic_step-0_continue',
    customer_name: additionalData?.fullName,
    customer_phone: additionalData?.phoneNumber,
    url: window.location.href,
    customer_email: additionalData?.email,
  }

  if (partner_ID) {
    const brandCommsObj = parseBrandComms(brandComms)

    payload = {
      ...payload,
      item_name: 'add-customer_brand-specific_step-0_continue',
      partner_ID: partner_ID.toString(),
      brand_name: brandCommsObj?.name,
      category_ID: brandCommsObj?.categoryId,
    }
  } else {
    payload.prod_categ_selected = additionalData?.customerIntent
  }

  return payload
}

const parseBrandComms = (brandComms: object | undefined) => {
  let brandCommsObj = {}

  if (brandComms?.en) {
    brandCommsObj = JSON.parse(brandComms?.en)
  }

  return brandCommsObj
}

interface IScreenViewPayload {
  user_ID: string
  screen_name: string
  partner_ID?: string
  brand_name?: string
  category_ID?: string
}

interface IClickActionPayload {
  user_ID: string
  item_name: string
  url: string
  customer_name: string
  customer_phone: string
  partner_ID?: string
  brand_name?: string
  category_ID?: string
  prod_categ_selected?: string
  customer_email: string
}
